import styled from "styled-components";
import { colors } from "utils";

export const ActionButton = ({
  children,
  tooltip = "Toggle button",
  ariaLabel,
  className = "",
  onClick = () => {},
  style = {},
  badge,
}) => {
  return (
    <Wrapper
      type="button"
      aria-label={ariaLabel || tooltip || "Action"}
      className={className}
      onClick={onClick}
      style={style}
    >
      {children}
      {badge && <Badge>{badge}</Badge>}
      {tooltip && <Tooltip className="tooltip">{tooltip}</Tooltip>}
    </Wrapper>
  );
};

const Wrapper = styled.button`
  width: 48px;
  height: 48px;
  padding: 0;
  cursor: pointer;
  position: relative;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid ${colors.nightlyWoods950};
  color: ${colors.nightlyWoods950};
  background: transparent;
  user-select: none;
  transition: background-color 0.2s ease-in-out;
  flex-shrink: 0;

  :hover {
    background-color: ${colors.milkGlass600};

    .tooltip {
      display: block;
      opacity: 1;
    }
  }

  :focus-visible {
    outline: 2px solid ${colors.blue800};
    outline-offset: 2px;
    .tooltip {
      display: block;
      opacity: 1;
    }
  }
`;

const Badge = styled.div`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 16px;
  height: 16px;
  border-radius: 60px;
  background: ${colors.pink500};
  color: white;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Tooltip = styled.div`
  background: ${colors.nightlyWoods500};
  position: absolute;
  display: none;
  color: white;
  right: 56px;
  padding: 6px;
  border-radius: 5px;
  white-space: nowrap;
  font-size: 16px;
`;

